import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik'
import { Modal } from 'antd';
import { Grid, TextField, Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import { firestore } from '../../config/firebaseConfig';


export default function WarehouseForm({visible, handleCancel, warehouse=null}) {

    const formSchema = Yup.object().shape({
        Name: Yup.string().required("champs doit etre remplis"),
        Location: Yup.string().required("champs doit etre remplis"),
    });

    const formik = useFormik({
        enableReinitialize : true,
        initialValues : {
            Name: warehouse ? warehouse?.Name : '',
            Location: warehouse ? warehouse?.Location : '',
           
        },
        validationSchema: formSchema,
        onSubmit: async (values,{ setErrors, setSubmitting, resetForm}) => {

            try {
                if(warehouse !== null){
                    firestore.collection('warehouses').doc(warehouse.id).set({...values});
                }else{
                    firestore.collection('warehouses').add({...values});
                }
                console.log(values);
                setSubmitting(false);
                toast.success("success")
                resetForm();
                handleCancel();
            } catch (error) {
                setSubmitting(false);
                toast.error("error");
                console.log(error);
                setErrors(error);
            }
        }
    })

    const {
        errors,
        touched,
        isSubmitting,
        handleSubmit,
        getFieldProps,
    } = formik;

    return (

        <Modal title="Ajout de Warehouse" visible={visible} footer={[]} confirmLoading={isSubmitting} onCancel={handleCancel}  width={700} >
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Name"
                                variant="outlined"
                                error={Boolean(touched.Name && errors.Name)}
                                helperText={touched.Name && errors.Name}
                                {...getFieldProps('Name')}
                            />
                        </Grid> 
                        <Grid item xs={8} sm={4}>
                            <TextField
                                label="Location"
                                variant="outlined"
                                error={Boolean(touched.Location && errors.Location)}
                                helperText={touched.Location && errors.Location}
                                {...getFieldProps('Location')}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} justify="flex-end">
                        <Grid item>
                            <Button  onClick={handleCancel} variant="contained" color="default">
                                annuler
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button type="submit" variant="contained" color="primary"  >
                                valider
                            </Button>
                        </Grid>
                        
                    </Grid>
                   
                </Form>
            </FormikProvider>
        </Modal>
    )
}
